export default class RemoveNotificationFeedback {
  public static createEmpty(): RemoveNotificationFeedback {
    return new RemoveNotificationFeedback();
  }
  constructor(
    public Id: number = 0,
    public FeedbacksCount: number = 0,
  ) {}
}
